
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion/credit_free_turnover",
      function () {
        return require("private-next-pages/promotion/credit_free_turnover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion/credit_free_turnover"])
      });
    }
  